import Image from "next/image"
import React, {useContext} from "react"
import Typography from "../../reusable/Typography/Typography"
import LayoutContext from "../../../context/LayoutContext"
import {ChevronRight} from "react-bootstrap-icons"
import Link from "next/link"
import DataContext from "../../../context/DataContext"
import {formatImageSrc} from "../../../strapi/strapiHelpers"
import {useTranslation} from "next-i18next"

function BrandWorldServiceCenter() {
	const {isMobile} = useContext(LayoutContext)
	const {brandWorld} = useContext(DataContext)
	const {t} = useTranslation()
	return (
		<div className="brandworld-service-center-box container">
			<div style={{gap: "40px"}}
				className="d-flex align-items-center flex-column flex-md-row justify-content-evenly col-12">
				{brandWorld.serviceCenter.serviceCentersMap.data[0].attributes.url ? <Image
					src={formatImageSrc(brandWorld.serviceCenter.serviceCentersMap.data[0].attributes.url)}
					width={476}
					height={303} /> : null}
				<div style={{maxWidth: "583px", paddingInline: "16px", gap: "24px"}}
					className="d-flex align-items-md-start align-items-center  justify-content-center flex-column">
					<Typography style={{textAlign: isMobile ? "center" : "left"}}
						variant="bodyLgBlack"
						className="typography-amount text-white " > {brandWorld.serviceCenter.title}
					</Typography>
					<Typography variant="bodySm"
						style={{fontSize: "16px", lineHeight: "24px", zIndex: "20", color: "#fff", textAlign: isMobile ? "center" : "left"}} >
						{ brandWorld.serviceCenter.description}
					</Typography>
					<Link href={brandWorld.serviceCenter.link}>
						<div className="d-flex align-items-center cursor-pointer justify-content-start gap-3">
							<Typography variant="bodySmBold"
								style={{fontSize: "16px", lineHeight: "24px", zIndex: "20", color: "#fff", textAlign: isMobile ? "center" : "left"}} >
								{t("service-centers-button-text")}
							</Typography>
							<ChevronRight color="#fff"
								style={{padding: "2px", borderRadius: "100px", background: "#323437"}} />
						</div>
					</Link>

				</div>
			</div>
		</div>
	)
}

export default BrandWorldServiceCenter
